import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceService } from '../services/auth-service.service';
// import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  resp: any;
  error: any;
  newP = false;
  public errorMsg: string;
  public errIncorrectOldP = false;
  public errUnmatched = false;



  constructor(private serverService: ServerService,
    private route: Router,
    private ngxService:NgxUiLoaderService,
    private authService: AuthServiceService,
   
  ) { }

  ngOnInit() {
  }
   
  // onClose(){
  //   this.dialogRef.close();
   
  // }


  logoutAllDevices() {
    this.serverService.logoutAllDevices()
      .subscribe(
        (response) => {
          this.authService.loggedOut();},
        


      );
  }

  logout(){
    this.serverService.logout()
    .subscribe(
      (response) => {
        this.authService.loggedOut();},
      

    
  );
    this.route.navigate(['/']);

  }

  onChangePassword(form: NgForm) {
    this.ngxService.start();
    const value = form.value;
    this.serverService
      .changePassword(value.newP, value.confirmP)
      .subscribe(
        (response) => {
          this.ngxService.stop();
          
          this.resp = response;
          if (this.resp.message) {
            Swal.fire(
             
               {
                title: 'Do you want to logout from all devices?',
                text: 'This action will log you out from all currently signed in devices.',
                icon:'warning',
                showCancelButton: true,
                showConfirmButton: true,
              }
              


            ).then((isConfirm) => {
              if (isConfirm.value) {
                this.logoutAllDevices();
              }
              else {
                this.logout();
                this.authService.loggedOut();
              }
            })
            this.route.navigate(['/']);
          }
        },

        (error) => {
          
          this.ngxService.stop();
          this.error = error
          Swal.fire("Oops!",
            this.error.error.message,
            "error"
           
          );
          if (this.errorMsg === "Password is incorrect") {
            form.controls.oldP.reset();
            this.errIncorrectOldP = true;






          }
          if (this.errorMsg === "Passwords do not match") {
            form.controls.confirmP.reset();
            this.errUnmatched = true;
          }
        }

      );
  }

  oncheckPassword(form: NgForm) {
    // this.ngxService.start();
    const value = form.value;
    this.serverService
      .checkPassword(value.oldP, value.confirmOldP)
      .subscribe(
        (response) => {
          // this.ngxService.stop();
          
          this.resp = response;
          
          if (this.resp.message ==  "password correct") {
            
            this.newP = true;}},

            (error) =>{
              this.error = error
              Swal.fire("warning",
                this.error.error.message,
               
              );
            }

              
              


            
          
         
         
        

        

      );
  }

 
 
  deleteAccount() {
    this.serverService.DeleteProfile()
      .subscribe();
  }

  onDeleteProfile() {
    Swal.fire('Are you sure?',
      'Delete Account?',
       'warning')
      .then((isConfirm) => {
      if (isConfirm) { this.authService.loggedOut();
        this.route.navigate(['/']);
        this. deleteAccount()
       
      }
      

    })
  }





}
